import axios from 'axios';

const instance = axios.create({
    //baseURL: 'http://127.0.0.1:8000/api/v2',
    baseURL: 'https://www.withudecors.com/admin/api/v2',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'System-Key': '$2y$10$HLpBttPppOi8AwbrcfR67O.vgG7m7uS7xliYJsVbCD3NRJZfHs4Gm' // From .env
    }
});

instance.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

instance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem("access_token");
            localStorage.removeItem("user");

            const path = window.location.pathname;
            const loginPath = "/login";
            const registerPath = "/register";

            if (path !== loginPath && path !== registerPath) {
                window.location.href = loginPath;
            }
        }
        return Promise.reject(error);
    }
);

export default instance;
